import React from 'react';
import moment from 'moment';

import { Grid, Typography } from '@material-ui/core';
import { TextField, CheckField, SelectField, DateField, Step } from '../SteppedForm';

import rules from './rules';

import './index.css';

const StepPersonal = (props) => {
  return (
    <Step
      id="personal"
      title={props.getPersonalDetailsTitle('Personal Details')}
      key={'personal-' + props.state.formdata.orgtype}>
      {props.state.formdata.orgtype === 'partnership' && props.state.applicant_index === 1 ? (
        <Typography variant="body1" class="formQuestion">
          Please enter the details of your second partner.
        </Typography>
      ) : (
        ''
      )}
      <Grid container>
        <Grid item xs={12} lg={6}>
          <SelectField id="title" label="Title" values={props.config.titles} required />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField id="firstname" label="First Name" required />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField id="othername" label="Other Names" />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField id="surname" label="Surname" required />
        </Grid>

        {props.state.formdata.onboardingFor !== 'vehicle' ? (
          <>
            <Grid item xs={12} lg={6}>
              <SelectField
                id="placeofbirth"
                label="Country of Birth"
                values={props.config.countries}
                required
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <DateField
                id="dob"
                label="Date of Birth"
                minDate={moment().add(-80, 'years')}
                maxDate={moment().add(-18, 'years')}
                required
              />
            </Grid>
            {props.state.formdata.orgtype !== 'company' ? (
              <Grid item xs={12} lg={6}>
                <TextField
                  id="abn"
                  label="ABN (without spaces)"
                  valid={rules.abn}
                  modify={(value) => props.limitLength(value, 11)}
                  required
                />
              </Grid>
            ) : (
              ''
            )}
            <Grid item className="centered" xs={12}>
              <CheckField id="gst" label={`Are you registered for GST with the ATO?`} />
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12} lg={6}>
              <TextField id="email" label="Email Address" valid={rules.email} required />
            </Grid>

            <Grid item xs={12} lg={6}>
              <TextField
                id="mobile"
                label="Mobile Phone"
                type="tel"
                inputProps={{ maxLength: 16 }}
                valid={rules.phone}
                required
              />
            </Grid>
          </>
        )}
      </Grid>
    </Step>
  );
};

export default StepPersonal;
